import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import { useSelector } from 'react-redux';

const TribesMetric = () => {
    const { industry_metrics } = useSelector((state)=>state.water_user);
    const classes = {
        aboutBox: { height: '80%', overflow: 'auto' },
        metricTitle: { fontSize: 18, fontWeight: 'bold', color: '#2352D0', marginBottom: 20, marginTop: 30 },
        metricSubTitle: { fontSize: 18, color: '#000000', marginBottom: 8 },
        metricValue: { fontSize: 24, fontWeight: 'bold', color: '#000000', marginBottom: 22 },
        operator: { fontSize: '40', fontWeight: 'bold', color: '#000000', marginBottom: 22 }
    };

    return (
        <Grid item xs={12} className={classes.aboutBox}>
            <Typography variant="h5" component="p" style={classes.metricTitle}>
                Mining
            </Typography>
            <Typography variant="body2" component="div" style={classes.metricSubTitle}>
                NIA
            </Typography>
            <Typography variant="h6" component="div" style={classes.metricValue}>
                { industry_metrics !== null ? industry_metrics['Mining']?.nia_contract_entitlement.toLocaleString("en-US") + ' acre-feet' : 0 }
            </Typography>
            <Typography variant="body2" component="div" style={classes.metricSubTitle}>
                Leased
            </Typography>
            <Typography variant="h6" component="div" style={classes.metricValue}>
                { industry_metrics !== null ? industry_metrics['Mining']?.leases_exchanges.toLocaleString("en-US") + ' acre-feet' : 0 }
            </Typography>
            <Typography variant="body2" component="div" style={classes.metricSubTitle}>
                {"M&I"}
            </Typography>
            <Typography variant="h6" component="div" style={classes.metricValue}>
                { industry_metrics !== null ? industry_metrics['Mining']?.mi_contract_entitlement.toLocaleString("en-US") + ' acre-feet' : 0 }
            </Typography>
            <Typography variant="body2" component="div" style={classes.metricSubTitle}>
                Indian
            </Typography>
            <Typography variant="h6" component="div" style={classes.metricValue}>
                { industry_metrics !== null ? industry_metrics['Mining']?.indian_contract_entitlement.toLocaleString("en-US") + ' acre-feet' : 0 }
            </Typography>
            <Typography variant="h5" component="p" style={classes.metricTitle}>
                Power
            </Typography>
            <Typography variant="body2" component="div" style={classes.metricSubTitle}>
                NIA
            </Typography>
            <Typography variant="h6" component="div" style={classes.metricValue}>
                { industry_metrics !== null ? industry_metrics['Power']?.nia_contract_entitlement.toLocaleString("en-US") + ' acre-feet' : 0 }
            </Typography>
            <Typography variant="body2" component="div" style={classes.metricSubTitle}>
                Leased
            </Typography>
            <Typography variant="h6" component="div" style={classes.metricValue}>
                { industry_metrics !== null ? industry_metrics['Power']?.leases_exchanges.toLocaleString("en-US") + ' acre-feet' : 0 }
            </Typography>
            <Typography variant="body2" component="div" style={classes.metricSubTitle}>
                {"M&I"}
            </Typography>
            <Typography variant="h6" component="div" style={classes.metricValue}>
                { industry_metrics !== null ? industry_metrics['Power']?.mi_contract_entitlement.toLocaleString("en-US") + ' acre-feet' : 0 }
            </Typography>
            <Typography variant="body2" component="div" style={classes.metricSubTitle}>
                Indian
            </Typography>
            <Typography variant="h6" component="div" style={classes.metricValue}>
                { industry_metrics !== null ? industry_metrics['Power']?.indian_contract_entitlement.toLocaleString("en-US") + ' acre-feet' : 0 }
            </Typography>
        </Grid>
    );
};

export default TribesMetric;